import { axiosApi } from '../globals';

export namespace trellis {
  export const generate = async (file: File, source: string, version: string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('source', source);
    formData.append('version', version);

    console.time('3d.generate');
    const res = await axiosApi.run('post', '/trellis', formData);
    console.timeEnd('3d.generate');

    return res;
  };
}
